import { SPELL_ID } from '../ids/spell-id'
import { SpellMap } from 'web/data/models'
import { TALENT_ID } from '../ids/talent-id'
import { MONK_TALENTS } from '../talents/monk'
import { MODIFIER_ID } from '../ids/modifier-id'
import { copyTalentPropsToSpell } from 'web/data/core-data'

export const MONK_SPELLS: SpellMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Mistweaver
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.MONK.MW.REVIVAL]: {
        id: SPELL_ID.MONK.MW.REVIVAL,
        talentId: undefined,

        name: "Revival",
        shortName: "Rev",

        cooldown: 180,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        game_id: 115310,
        icon_name: "spell_monk_revival",
    },

    [SPELL_ID.MONK.MW.CHI_JI]: {
        id: SPELL_ID.MONK.MW.CHI_JI,
        cooldown: 180,
        affectedByModifierIds: [],

        ...copyTalentPropsToSpell(MONK_TALENTS[TALENT_ID.MONK.MW.CHI_JI])
    },

}
